<template>
  <div>
    <PlantillaLogin>
      <div slot="contenido">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <div
          class="columns is-centered"
          style="--eye-translate-x:0%; --eye-rotate:0deg; --eye-scale:1; --eye-fill:#00698f;"
        >
          <article class="column card is-full-mobile is-two-thirds-tablet is-half-desktop form">
            <form class="card-content" action v-on:submit.prevent="conectar">
              <h2 class="title has-text-primary">Servicio de Salud Magallanes</h2>
              <hr />

              <div class="field is-floating-label">
                <label for="username" class="label is-medium">Correo Electrónico</label>
                <div class="control has-icons-left is-medium is-clearfix">
                  <input
                    autocomplete="on"
                    class="input is-medium data-hj-whitelist"
                    v-model="user.email"                    
                    type="email"
                    placeholder="Correo Electrónico"
                    autofocus
                    required
                  />
                  <span class="icon is-left">
                      <span class="icon is-left">
                                <i class="fas fa-user icon"></i>

                  </span>
                  </span>
                </div>
              </div>
              <div class="field is-floating-label">
                <label for="password" class="label is-medium">Contraseña</label>
                <div class="control has-icons-left has-icons-right is-medium is-clearfix">
                  <input
                    type="password"
                    autocomplete="on"
                    class="input is-medium"
                    v-model="user.password"
                    placeholder="Contraseña"
                    @enter="conectar"
                    required
                  />
                  <span class="icon is-left">
                      <i class="fas fa-lock icon"></i>
                  </span>
                </div>
              </div>                
      
              <div class="field">
                <p class="control">
                  <button type="submit" class="button is-medium is-primary is-fullwidth">
                    <span>Ingresar</span>
                    <span class="icon is-small">
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fas"
                        data-icon="sign-in-alt"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                        class="svg-inline--fa fa-sign-in-alt fa-w-16 fa-xs"
                      >
                        <path
                          fill="currentColor"
                          d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                          class
                        />
                      </svg>
                    </span>
                  </button>
                </p>
              </div>
            </form>
            <div class="field">
              <b-message type="is-danger" v-if="error">{{error}}</b-message>
              <!-- <label class="checkbox"></label> -->
            </div>
          </article>
          <article
            class="column card is-hidden-mobile is-on-thirds-tablet is-half-desktop back-img"
          >
            <img src="/login-wallpaper.jpg" />
          </article>
        </div>
      </div>
    </PlantillaLogin>
  </div>
</template>
<script>
import PlantillaLogin from "../template/PlantillaLogin";

//import { getRolesByEmail } from "@/services/role";

export default {
  name: "Login",
  components: {
    PlantillaLogin: PlantillaLogin,
  },
  data() {
    return {
      user: {
        email: "",
        password: "",
        grant_type: "password",
        token: "",    
        role_id:0    
      },      
      error: "",
      areStablishmentsLoading: false,
      isLoading: false,
      isExpanded:true,
      listRoles:[],

    };
  },

 methods: {
    async conectar() {
      this.error = "";
      this.isLoading = true;      
      this.$http
        .post("api/auth", {
          email: this.user.email,
          password: this.user.password,
          grant_type: this.user.grant_type,
        })
        .then(async (response) => {          
          this.user.token = response.body.token;
          this.user.role_id=response.body.user.role_id;
          window.localStorage.setItem("token", (this.user.token = response.body.token));
          window.localStorage.setItem("userName", `${response.body.user.name} ${response.body.user.apepat} ${response.body.user.apemat}`);                 
          window.localStorage.setItem("stablishment_id", response.body.user.stablishment_id);
          window.localStorage.setItem("role_id", this.user.role_id);          
          window.localStorage.setItem("user", JSON.stringify(response.body.user));          
          this.isLoading = false;
          switch (this.user.role_id) {
            case 1:              
              window.localStorage.setItem("perfil","directive");
              this.$router.push({ name: "directiveReport" });
              this.isLoading = false;
              break;
            case 2:              
              window.localStorage.setItem("perfil","manager");
              this.$router.push({ name: "administratorReport" });
              this.isLoading = false;
              break;
            case 3:     
             window.localStorage.setItem("perfil","administrative",); 
              this.$router.push({ name: "administrativeHome" });
              this.isLoading = false;
              break;
          }
        
        })
        .catch((response) => {
          this.isLoading = false;
          this.error = "Usuario y/o contraseña incorrecta";
          console.error(response);
        });
    },
  },
};
</script>